import PropTypes from 'prop-types';

/**
 *
 */
const questionsShape = PropTypes.shape({
  code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  sequence: PropTypes.number,
  // todo .....
});

/**
 *
 */
const questionsGroupsShape = PropTypes.shape({
  code: PropTypes.string.isRequired,
  sequence: PropTypes.number,
});

/**
 *
 */
const groupsShape = PropTypes.shape({
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  sequence: PropTypes.number,
  questions: PropTypes.arrayOf(questionsGroupsShape).isRequired,
});

/**
 *
 */
const partsShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  mandatory: PropTypes.bool.isRequired,
  description: PropTypes.string,
  questions: PropTypes.arrayOf(questionsShape).isRequired,
  groups: PropTypes.arrayOf(groupsShape),
});

/**
 *
 */
const questionnaireShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  code: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  sequence: PropTypes.number,
  parts: PropTypes.arrayOf(partsShape).isRequired,
});

export { questionnaireShape };
